import { render } from "./SingleImageUpload.vue?vue&type=template&id=b162ba1a&ts=true"
import script from "./SingleImageUpload.vue?vue&type=script&lang=ts"
export * from "./SingleImageUpload.vue?vue&type=script&lang=ts"

import "./SingleImageUpload.vue?vue&type=style&index=0&id=b162ba1a&lang=scss"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__